import { useRef, useState } from 'react';
import {
  Box,
  Grid,
  LinearProgress,
  Paper,
  TextField,
  Alert,
  Snackbar,
  SnackbarCloseReason
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import {
  VForm,
  useVForm,
  AutoCompleteProdutos,
  AutoCompleteCliente,
  AutoCompleteFabrica
} from '../../../shared/forms';
import { FerramentasDeDetalheVendas } from '../../../shared/components';
import { LayoutBaseVendas } from '../../../shared/layouts';
import { PedidoDiretoService } from '../../../shared/services/api/vendas/pedidodireto/PedidoDiretoService';

interface IFormData {
  idcli: string;
  idfabrica: string;
  datalan: Date;
  numero: number;
};

export const PrecoCliente: React.FC = () => {
  const { id = 'novo' } = useParams<'id'>();
  const navigate = useNavigate();
  const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [tipo, setTipo] = useState('p.idprod');
  const [uuidcli, setUuidcli] = useState('');
  const [idfabrica, setIdfabrica] = useState('');
  const codigoref = useRef<HTMLInputElement>(null);
  const [selectedProduto, setSelectedProduto] = useState<string | undefined>();
  const [preco, setpreco] = useState('');
  const [openalert, setOpenAlert] = useState(false);
  const [msg, setMsg] = useState('');

  const handleuuidProd = (uuid: string | undefined) => {
    if (uuid != null) {
     
      setIsLoading(true);
      try {
        PedidoDiretoService.getProdutos(tipo, idfabrica, uuidcli, uuid)
         .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setMsg(result.message);
            setOpenAlert(true);
          } else {
            // Verifica se o preço é null ou undefined
            if (result.preco == null) {
              setMsg("Percentual não encontrado");
              setOpenAlert(true);
              setpreco('0.00'); // Define um valor padrão
            } else {
              setpreco(result.preco.toFixed(2)); 
            }
          }
         
        });
        setIsLoading(false);
        setTimeout(() => {
          codigoref.current?.focus();
        }, 0);
  
      } catch (error: any) {
        setIsLoading(false);
        setMsg(error.message)
        setOpenAlert(true);
        setTimeout(() => {
          codigoref.current?.focus();
        }, 0);
      }   
    }  
  };

  

  

  

  const handleuuidCli = (uuid: string | undefined) => {
    if (uuid) setUuidcli(uuid);
    setpreco('');
  };

  const handlefabrica = (uuidfabrica: string | undefined) => {
    setIdfabrica(uuidfabrica || '');
    setpreco('');
  };

  const handleCloseAlert = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') return;
    setOpenAlert(false);
  };

  return (
    <LayoutBaseVendas
      barraDeFerramentas={
        <FerramentasDeDetalheVendas
          textoBotaoNovo='Novo'
          mostrarBotaoImpressao1={false}
          mostrarBotaoSalvar={false}
          mostrarBotaoImpressaopequeno={false}
          mostrarBotaoSalvarEFechar={false}
          mostrarBotaoSalvarCarregando={isLoading}
          mostrarBotaoSalvarEFecharCarregando={isLoading}
          mostrarBotaoApagar={id !== 'novo'}
          mostrarBotaoNovo={id !== 'novo'}
          mostrarBotaoImpressao={id !== 'novo'}
          mostrarBotaoApagarCarregando={isLoading}
          disableBotaoSalvar={ true}
          disableBotaoSalvarEFechar={ true}
          aoClicarEmSalvar={save}
          aoClicarEmSalvarEFechar={saveAndClose}
          aoClicarEmVoltar={() => navigate('/talaopedido')}
          aoClicarEmNovo={() => navigate('/talaopedido/novo')}
         
        />
      }
    >
      <Box display="flex" justifyContent="center" alignItems="center" width="100%">
        <Box
          component={Paper}
          variant="outlined"
          maxWidth="1000px"
          width="100%"
          padding={2}
          margin={1}
        >
          <VForm ref={formRef} onSubmit={handleuuidProd}  placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <Snackbar
              open={openalert}
              autoHideDuration={1200}
              onClose={handleCloseAlert}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <Alert
                onClose={handleCloseAlert}
                severity="error"
                variant="filled"
                sx={{ width: '100%' }}
              >
                {msg}
              </Alert>
            </Snackbar>

            <Grid container direction="column" spacing={2}>
              {isLoading && (
                <Grid item>
                  <LinearProgress variant='indeterminate' />
                </Grid>
              )}

              <Grid container item spacing={2}>
                
                <Grid item xs={12} md={7}>
                  <AutoCompleteCliente
                    isExternalLoading={isLoading}
                    uuidcli={handleuuidCli}
                  />
                </Grid>
                <Grid item xs={12} md={5}>
                  <AutoCompleteFabrica
                    uuidfabrica={handlefabrica}
                    isExternalLoading={isLoading}
                  />
                </Grid>
                <Grid item xs={12} md={7}>
                  <AutoCompleteProdutos
                    uuidprod={handleuuidProd}
                    isExternalLoading={isLoading}
                  />
                </Grid>
                <Grid item xs={12} md={5}>
  <TextField
    fullWidth
    value={preco ? Number(preco).toLocaleString('pt-BR', {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4
    }) : ''}
    disabled={true}
    
    size="small"
    label="Preço"
    InputProps={{
      style: {
        fontWeight: "bold",
        color: "black", // Mantém o texto preto mesmo desabilitado
      },
    }}
  />
</Grid>
              </Grid>
            </Grid>
          </VForm>
        </Box>
      </Box>
    </LayoutBaseVendas>
  );
};
